import { useGlobalForm } from '@workspace/core-ts/contexts';
import { cn } from '@workspace/utils';
import opinions_assurances from '../assets/opinions_assurances.svg';

type FooterLink = {
    label: string;
    href?: string;
    hrefAMO?: string;
    hrefAMGestion?: string;
};

const linksAMO: FooterLink[] = [
    {
        label: 'Mentions légales',
        href: 'https://www.april-moto.com/wp-content/uploads/2022/07/26.06.2022-CGU-Groupe-April.pdf',
    },
    {
        label: 'Gestion des cookies',
        href: 'https://www.april-moto.com/gestion-des-cookies/',
    },
    {
        label: 'Politique des données personnelles',
        href: 'https://www.april-moto.com/wp-content/uploads/2021/11/Lettre-RGPD-APRIL-Moto-AM21-11.pdf',
    },
    {
        label: 'Traitement de vos réclamations',
        href: 'https://assets.april.fr/prismic/documents/juridique/doc-april-traitement-reclamations.pdf?func=proxy',
    },
    {
        label: 'Fonctionnement du Tarificateur',
        href: 'https://www.april-moto.com/wp-content/uploads/2022/07/26.06.2022-Rubrique-Fonctionnement_Groupe-April.pdf',
    },
];

const linksAMGestion: FooterLink[] = [
    {
        label: 'Mentions légales',
        href: 'https://amgestionassurance.com/mentions-legales.html',
    },
    {
        label: 'Gestion des cookies',
        href: 'https://amgestionassurance.com/gestion-cookies.html',
    },
    {
        label: 'Politique des données personnelles',
        href: 'https://www.amgestionassurance.com/Doc/Lettre-RGPD-AM-Gestion-11.2021.pdf',
    },
    {
        label: 'Traitement de vos réclamations',
        href: 'https://amgestionassurance.com/#reclamations',
    },
];

export function Footer() {
    const { others, config } = useGlobalForm();

    const gestionnaireIsAMO = others?.gestionnaire?.codeBelair === 43397;

    const footerConfig = config?.footer ?? {
        showBanner: true,
        showLinks: true,
    };

    const displayLinks: FooterLink[] = footerConfig.customLinks ?? (gestionnaireIsAMO ? linksAMO : linksAMGestion);

    return (
        <footer className="flex flex-col">
            {footerConfig.showBanner !== false && (
                <div className="bg-background w-full no-padding-root flex justify-center py-4">
                    <img
                        src={opinions_assurances}
                        alt="Opinions Assurances"
                        className="h-full"
                    />
                </div>
            )}

            {footerConfig.showLinks !== false && (
                <div className={cn('bg-white py-4 flex flex-wrap justify-center text-[10px] sm:text-xs lg:gap-3 xl:gap-8 padding-root')}>
                    {displayLinks.map((link, index) => (
                        <a
                            className="text-gray-500 whitespace-nowrap underline p-1 hover:text-primary"
                            href={link.href}
                            key={index}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {link.label}
                        </a>
                    ))}
                </div>
            )}
        </footer>
    );
}
